import { Box } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import React, { ReactNode } from 'react'

export interface LayoutRouteProps {
  children?: ReactNode
}

const MainLayout: React.FC<LayoutRouteProps> = ({ children }) => {
  const theme = useTheme()

  return (
    <Box
      // using this id tells bnet header's skip button to jump to first
      // focusable element within this component
      id="_bnMainInternal"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '80vh',
      }}
    >
      <Box
        sx={{
          flex: 1,
          padding: '4rem',
          [theme.breakpoints.down('md')]: {
            padding: '1rem',
            paddingTop: '3rem',
          },
        }}
      >
        {children}
      </Box>
    </Box>
  )
}

export default MainLayout
